<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :vendedores="enableVendedores"
          :url="link"
        />
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Manifesto Saída
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationClientesParcipantes"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('341')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-manifesto-saida />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'PageManisfetoSaida',
    emits: ['updateDadosManifesto', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashboardManifestoSaida: () => import('../../components/comercial/manifesto/TableManisfetoSaida'),
    },
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      $vendedor: [],
      link: window.location.href,
      paginaEnable: false,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableVendedores: true,
      codigo: 0,
      orientacao: [],
      codigoIds: ['341'],
      textoManifesto: '',
      dynamicPaddingManifestoSaida: '',
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Manifesto Saída')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1380) {
          this.dynamicPaddingManifestoSaida = 'padding-right: 109rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingManifestoSaida = 'padding-right: 11rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingManifestoSaida = 'padding-right: 30rem !important'
        } else {
          this.dynamicPaddingManifestoSaida = 'padding-right: 67rem !important'
        }
      },

      handleUpdateDados (dataInicial, dataFinal, empresaSelect, vendedorSelect, area, rede, supervisor) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.vendedor = vendedorSelect

        localStorage.setItem('dataInicial', this.dataInicial)
        localStorage.setItem('dataFinal', this.dataFinal)
        localStorage.setItem('empresa', JSON.stringify(empresaSelect || []))
        localStorage.setItem('supervisor', JSON.stringify(supervisor || []))
        localStorage.setItem('vendedor', JSON.stringify(this.vendedor || []))
        localStorage.setItem('area', JSON.stringify(area || []))
        localStorage.setItem('rede', JSON.stringify(rede || []))
        localStorage.setItem('updateDadosFiltros', true)

        this.updateDados()
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      updateDados () {
        eventEmit.$emit('update-dados-manifesto', this.dataInicial, this.dataFinal, this.vendedor)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }
</style>

<style lang="sass">
  #iconInformationManifestoSaida
    margin: 0 0 0 4rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemManifestoSaida
    margin: -2rem 0 0 -1rem

</style>
